import { Directive, ElementRef, Input, OnDestroy, OnInit } from '@angular/core';

/**
 * Blocks mousedown and click in capture phase when condition is true.
 * Allows hover (mouseover/mouseenter) to pass through for tooltips.
 * Use on wrapper when isViewOnly to prevent dropdown/datepicker from opening.
 */
@Directive({
  selector: '[appPreventClickInViewMode]',
  standalone: false
})
export class PreventClickInViewModeDirective implements OnInit, OnDestroy {
  @Input() appPreventClickInViewMode = false;

  private boundHandler = (event: Event) => this.handleEvent(event);

  constructor(private el: ElementRef<HTMLElement>) {}

  ngOnInit(): void {
    const native = this.el.nativeElement;
    native.addEventListener('mousedown', this.boundHandler, { capture: true });
    native.addEventListener('click', this.boundHandler, { capture: true });
  }

  ngOnDestroy(): void {
    const native = this.el.nativeElement;
    native.removeEventListener('mousedown', this.boundHandler, {
      capture: true
    });
    native.removeEventListener('click', this.boundHandler, { capture: true });
  }

  private handleEvent(event: Event): void {
    if (this.appPreventClickInViewMode) {
      event.preventDefault();
      event.stopPropagation();
    }
  }
}
